module.exports = {
	"Announcement": {
		"Know More": "Подробнее"
	},
	"Appointment": {
		"Conditions": "Нажимая на кнопку «Подтвердить», вы подтверждаете, что ознакомились с разделом «Положение о неприкосновенности частной жизни» и даете согласие на обработку компанией «Кристиан Диор Кутюр» ваших персональных данных на условиях, определенных в разделе «Положение о неприкосновенности частной жизни», с целью ответа на ваш запрос.",
		"Confirmation": "Мы получили Ваш запрос на встречу с консультантом в бутике. В ближайшее время Вы получите подтверждение по электронной почте.",
		"Description": "Назначьте встречу в бутике Dior, чтобы получить индивидуальную консультацию.",
		"Get an appointment": "Назначить встречу в бутике",
		"Motives": "цель",
		"Universes": "Вселенная"
	},
	"DiorMap": {
		"Search in this area": "Искать поблизости"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Результат",
			"other": "%(count)s Результаты",
			"zero": "%(count)s Результат"
		},
		"Refine": "Расширенный поиск",
		"RefineAria": "Уточнить поиск, отметив нужное",
		"Are you looking for?": "Вы ищете бутик, связанный с разделами «Для женщин», «Для мужчин», «Для детей», «Ювелирные украшения или Часы»?"
	},
	"Footer": {
		"Download the applications": "Загрузить приложения",
		"Language": "Язык",
		"Newsletter": "Пример: Christian@dior.fr",
		"Ok": "Ок",
		"Subscribe to newsletter": "Подписаться на новостную рассылку"
	},
	"Form": {
		"All fields are mandatory": "Все поля обязательны для заполнения",
		"Civility": "Обращение",
		"Comments": "комментарии",
		"Conditions": "Если Вы хотите получить подтверждение от %(brand)s на электронную почту, поставьте галочку здесь. У Вас есть право на доступ к Вашим персональным данным, внесение в них изменений и их удаление. Вы также можете отказаться от обработки данных, отправив запрос на адрес \"contact@dior.com\"",
		"Date": "Дата ",
		"Email": "E-mail",
		"Hour": "Время",
		"Invalid E-mail address": "Неверный адрес электронной почты",
		"Mr": "Г-н",
		"Mrs": "Г-жа",
		"Name": "Фамилия",
		"Phone": "Телефон",
		"Required fields": "Обязательные поля",
		"Submit": "Подтвердить",
		"Surname": "Имя"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Бутики Dior в вашем городе: haute couture, ароматы, кожаные изделия",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Прибытие",
		"Departure": "Отправление",
		"Details": "Детали",
		"Error": "К сожалению, нам не удалось выстроить требуемый маршрут. Пожалуйста, измените пункт отправления и/или тип транспортного средства.",
		"Follow the itinerary": "Проследовать по маршруту",
		"Itinerary": "Маршрут",
		"modeBICYCLING": "Выстроить маршрут на велосипеде",
		"modeDRIVING": "Выстроить маршрут на автомобиле",
		"modeTRANSIT": "Выстроить маршрут на транспорте",
		"modeWALKING": "Выстроить маршрут пешком",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Используйте телефон в портретном режиме"
	},
	"NavMobile": {
		"Home": "Главная"
	},
	"Newsletter": {
		"Dior Newsletter": "Новостная рассылка Dior",
		"Fashion and accessories": "Мода и аксессуары",
		"I wish to receive the %(newsletter)s newsletter": "Я хочу получать новости %(newsletter)s",
		"Newsletter Confirmation": "Вы успешно подписались на новостную рассылку",
		"Perfume and beauty": "Ароматы и красота",
		"Receive our newsletter": "Подпишитесь на нашу новостную рассылку",
		"Your universes": "Разделы"
	},
	"ResultsBlock": {
		"Dior boutiques": "Бутики Dior",
		"Too far": "СЛИШКОМ МНОГО РЕЗУЛЬТАТОВ. УТОЧНИТЕ ЗАПРОС, ВЫБРАВ БОЛЕЕ КОНКРЕТНУЮ ОБЛАСТЬ ПОИСКА.",
		"No result": "Не найдено ни одного бутика",
		"Other shops": "Другие бутики",
		"Results": "Результаты поиска",
		"Fewer results, zoom in": "ПОКАЗАТЬ МЕНЬШЕ, zoom in",
		"More results, zoom out": "ПОКАЗАТЬ БОЛЬШЕ, zoom out",
		"Fewer results": "ПОКАЗАТЬ МЕНЬШЕ",
		"More results": "ПОКАЗАТЬ БОЛЬШЕ"
	},
	"SearchBlock": {
		"Geolocation": "Использовать геолокацию для поиска бутиков рядом с вами",
		"Search": "Поиск"
	},
	"Share": {
		"Conditions": "Если Вы хотите получить подтверждение от %(brand)s на электронную почту, поставьте галочку здесь. У Вас есть право на доступ к Вашим персональным данным, внесение в них изменений и их удаление. Вы также можете отказаться от обработки данных, отправив запрос на адрес \"contact@dior.com\"",
		"Recipient": "Данные получателя",
		"Share Confirmation": "Информация о бутике отправлена",
		"Share this shop": "Поделиться информацией о бутике",
		"Your favorite shop": "Ваш любимый бутик"
	},
	"ShopBlock": {
		"Closed": "Закрыто",
		"Closed today": "Сегодня закрыт",
		"Directions": "Маршрут",
		"DirectionsAria": "Проложить маршрут до %(shopName)s",
		"Make an appointment": "Назначить встречу",
		"Open": "Открыт",
		"Opening time": "Часы работы",
		"OpeningAria": "Получить больше информации о часах работы",
		"ResultNumber": "Результат № %(number)s",
		"Services": "Услуги",
		"ServicesAria": "Получить больше информации об услугах",
		"Share": "Поделиться",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Открыт сегодня до %(hour)s",
		"Universes": "Вселенная",
		"UniversesAria": "Получить больше информации о похожих Вселенных",
		"and": "and",
		"from": "from",
		"publicHolidays": "Возможно, бутик закрыт",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/ru_ru/translations.json
// module id = 873
// module chunks = 0